<template>
  <footer class="app-footer text-center text-muted py-3 mt-auto">
    <div class="container">
      <i class="bi bi-c-circle me-1" aria-hidden="true"></i>
      <span>2025-2026 Christoph Wienands</span>
    </div>
  </footer>
</template>

<style scoped>
.app-footer {
  font-size: 0.875rem;
}
</style>
